import PropTypes from 'prop-types';
import React from 'react';

import StatusChip from '@sophocles/components/StatusChip';

/**
 * StatusBadge component for displaying operational report status
 */
const StatusBadge = ({ status }) => {
  const getStatusConfig = statusValue => {
    const statusLower = statusValue?.toLowerCase();

    switch (statusLower) {
      case 'passed':
        return {
          label: 'Passed',
          color: 'ok',
        };
      case 'failed':
        return {
          label: 'Failed',
          color: 'bad',
        };
      case 'pending':
        return {
          label: 'Pending',
          color: 'warning',
        };
      case 'in_progress':
        return {
          label: 'In Progress',
          color: 'info',
        };
      case 'error':
        return {
          label: 'Error',
          color: 'bad',
        };
      case 'skipped':
        return {
          label: 'Skipped',
          color: 'neutral',
        };
      default:
        return {
          label: statusValue || 'Unknown',
          color: 'neutral',
        };
    }
  };

  const config = getStatusConfig(status);

  return <StatusChip label={config.label} color={config.color} />;
};

StatusBadge.propTypes = {
  status: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['small', 'medium']),
};

export default StatusBadge;
